// src/contexts/SocketContext.js
import React, { createContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { jwtDecode } from "jwt-decode"; // ✨ 추가

export const SocketContext = createContext();

export const SocketContextProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => {
    try {
      const t = localStorage.getItem("token");
      return t ? jwtDecode(t).userId : null;
    } catch {
      return null;
    }
  });
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  // ── 1) 토큰이 바뀔 때마다 (한 번만) userId 디코딩 (CommonJS require 사용)
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const { userId: id } = jwtDecode(token);
      setUserId(id);
    } catch (err) {
      console.error("SocketContext: JWT decoding failed", err);
    }
  }, []);

  // ── 2) 소켓 연결
  useEffect(() => {
    const url = process.env.REACT_APP_SOCKET_URL;
    if (!url) {
      console.error("SocketContext: SOCKET_URL missing");
      return;
    }
    const s = io(url, {
      transports: ["websocket", "polling"],
      path: "/socket.io",
    });
    s.on("connect", () => setIsConnected(true));
    s.on("disconnect", () => setIsConnected(false));
    s.on("connect_error", (e) => console.error("Socket error", e));
    setSocket(s);
    return () => {
      s.disconnect();
    };
  }, []);

  // ── 3) Context API 로 내보낼 메서드들
  const joinRoom = (roomId) => socket?.emit("joinRoom", { roomId, userId });
  const sendMessage = ({ roomId, message }) =>
    socket?.emit("sendMessage", { roomId, userId, message, time: new Date() });
  const deleteMsg = (msgId, roomId) =>
    socket?.emit("deleteMessage", { messageId: msgId, roomId });

  const onInitMessages = (cb) => {
    socket?.on("initMessages", cb);
    return () => socket?.off("initMessages", cb);
  };
  const onMessage = (cb) => {
    socket?.on("receiveMessage", cb);
    return () => socket?.off("receiveMessage", cb);
  };
  const onDeleteMessage = (cb) => {
    socket?.on("messageDeleted", cb);
    return () => socket?.off("messageDeleted", cb);
  };

  return (
    <SocketContext.Provider
      value={{
        socket,
        isConnected,
        userId,
        setUserId,
        joinRoom,
        sendMessage,
        deleteMessage: deleteMsg,
        onInitMessages,
        onMessage,
        onDeleteMessage,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
